export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8261.6ed4a7d9.jpg";